<template>
<div class="animated fadeIn">
  <b-card>
    <b-button-toolbar class="pull-right">
      <b-btn variant="primary" @click="showAddBuilding">Add Building</b-btn>
    </b-button-toolbar>
  </b-card>

  <b-card>
    <v-client-table :data="buildings" :columns="columns" :options="options" :theme="theme" id="dataTable" ref="dataTable">
      <template slot="actions" slot-scope="data">
        <b-button class="mr-1" size="sm" variant="primary" @click="showEditModal(data.row)"><i class="fa fa-pencil"></i></b-button>
        <b-button class="mr-1" size="sm" variant="primary" @click="showSetAttributeModal(data.row)">Set Attributes</b-button>
        <b-button size="sm" variant="primary" :to="{name: 'Floors', params: {id: data.row.id}}">Manage Floors</b-button>
      </template>
      <template slot="attributes" slot-scope="data">
        <ul>
          <li v-for="atrribute in data.row.attributes">
            {{ atrribute.name }}: {{ atrribute.value }}
          </li>
        </ul>
      </template>
      <span slot="is_active" slot-scope="data">{{data.row.is_active ? 'Yes' : 'No'}}</span>
    </v-client-table>
  </b-card>

  <div>
    <b-modal ref="modalAddBuilding" title="Add Building" hide-footer @hide="hideAddBuilding" no-enforce-focus>
      <building-form-add v-if="canShowAddBuilding" @success="addBuildingSuccess" @cancel="cancelAddBuilding" />
    </b-modal>
    <b-modal ref="modalEditBuilding" title="Edit Building" hide-footer @hide="hideEditBuilding" no-enforce-focus>
      <building-form-edit v-if="selectedBuilding" :building="selectedBuilding" @success="editBuildingSuccess" @cancel="cancelEditBuilding" />
    </b-modal>
    <b-modal ref="modalSetAttributes" title="Set Attributes" hide-footer @hide="hideSetAttributes" no-enforce-focus>
      <set-attributes v-if="selectedSetAttributes" :object="selectedSetAttributes" type="BUILDING" @success="setAttributeSuccess" @cancel="hideSetAttributes" />
    </b-modal>
  </div>
</div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import BuildingFormAdd from './BuildingFormAdd'
import BuildingFormEdit from './BuildingFormEdit'
import SetAttributes from './SetAttributes'

export default {
  name: 'BuildingList',
  components: {
    BuildingFormAdd,
    BuildingFormEdit,
    SetAttributes
  },
  computed: mapState({
    buildings: state => state.buildings.all,
  }),
  data: function() {
    return {
      columns: [
        'id',
        'name',
        'manager',
        'phone',
        'floors.length',
        'total_rooms',
        'attributes',
        'is_active',
        'actions'
      ],
      options: {
        headings: {
          'id': 'ID',
          'floors.length': 'Floors',
          'total_rooms': 'Rooms',
          'is_active': 'Active',
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
      canShowAddBuilding: false,
      selectedBuilding: null,
      selectedSetAttributes: null
    }
  },
  methods: {
    showAddBuilding() {
      this.canShowAddBuilding = true
      this.$refs.modalAddBuilding.show()
    },
    cancelAddBuilding() {
      this.$refs.modalAddBuilding.hide()
    },
    addBuildingSuccess() {
      this.$refs.modalAddBuilding.hide()
      this.$store.dispatch('buildings/getBuildings')
    },
    hideAddBuilding() {
      this.canShowAddBuilding = false
    },
    showEditModal(building) {
      this.selectedBuilding = building
      this.$refs.modalEditBuilding.show()
    },
    editBuildingSuccess() {
      this.$refs.modalEditBuilding.hide()
      this.refresh()
    },
    cancelEditBuilding() {
      this.$refs.modalEditBuilding.hide()
    },
    hideEditBuilding() {
      this.selectedBuilding= null
    },
    showFloorModal(building) {
      this.selectedBuilding = building
      this.$refs.modalFloors.show()
    },
    showFloorModal(building) {
      this.selectedFloor = building
      this.$refs.modalFloors.show()
    },
    showSetAttributeModal(room) {
      this.selectedSetAttributes = room
      this.$refs.modalSetAttributes.show()
    },
    setAttributeSuccess() {
      this.hideSetAttributes()
      this.refresh()
    },
    hideSetAttributes() {
      this.selectedSetAttributes = null
      this.$refs.modalSetAttributes.hide()
    },
    refresh() {
      this.$store.dispatch('buildings/getBuildings')
    }
  },
  created () {
    this.refresh()
    this.$store.dispatch('attributes/getAttributes')
  }
}
</script>
